import React, { useEffect } from 'react';
import { Link as RouterLink, useLocation, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button } from '@material-ui/core';

import HyperText from '@/components/hypertext';
import { useUserMeQuery } from '@/graphql';
import PublicLayout from '../../components/layout';
import { useAuth } from '@/contexts/auth-context';
import { ProfessionTypesEnum } from '@/type';

const ComfirmEmail: React.FC = () => {
  const { t } = useTranslation();
  const { token } = useAuth();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const deepLinkHash = searchParams.get('hash');
  const email = searchParams.get('email');
  const { data } = useUserMeQuery({
    fetchPolicy: 'network-only',
    skip: !token,
  });

  useEffect(() => {
    if (email) {
      if (window.fbq) {
        window?.fbq('track', 'PageView');
        const isLeadDoctor = location.pathname.includes('doctor');
        const isLeadStudent = location.pathname.includes('student');
        window.fbq?.('track', isLeadDoctor ? 'LeadDoctor' : isLeadStudent ? 'LeadStudent' : 'Lead');
      }
    }
  }, [email, location.pathname]);

  const isSpecialist =
    data?.me?.profession?.type?.type === ProfessionTypesEnum.Doctor ||
    data?.me?.profession?.type?.type === ProfessionTypesEnum.MedicalAssistant;
  const onboardingPath = isSpecialist ? '/confirm-registration-doctors/' : '/onboard-welcome';

  return (
    <PublicLayout title={t('sign-up.completed.title')}>
      {(email || data?.me?.email) && (
        <>
          <Box marginTop={3} marginBottom={7}>
            <Typography variant="body2" component="p">
              <HyperText text={t('sign-up.completed.info')}>
                <Typography variant="caption" component="span" color="primary">
                  {/* TODO Handle when userRegistration is empty */}
                  {email || data?.me?.email}
                </Typography>
              </HyperText>
            </Typography>
          </Box>
          {data?.me && !data?.me?.confirmationToken && (
            <Button
              fullWidth
              data-cy-ok
              color="primary"
              variant="contained"
              component={RouterLink}
              to={`${deepLinkHash ? '/goto/' + deepLinkHash + '?source=signup' : onboardingPath}`}
            >
              {t('common.ok')}
            </Button>
          )}
        </>
      )}
    </PublicLayout>
  );
};

export default ComfirmEmail;
